import { reconciliationConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const loadReconciliations = ({ limit_param, sort_params, offset_param, start_date, end_date, city_of_school, country_of_school, is_donor_assigned, recipient_student_status }) => ({
    type: apiConstants.API,
    payload: {
        url: `${url.reportingFilter}?limit_param=${limit_param || ''}&sort_params=${sort_params || ''}&offset_params=${offset_param || ''}&start_date=${start_date || ''}&end_date=${end_date || ''}${city_of_school || ''}${country_of_school || ''}&is_donor_assigned=${is_donor_assigned || ''}&recipient_student_status=${recipient_student_status || ''}`,
        request: () => ({ type: reconciliationConstants.LOAD_RECONCILIATIONS_REQUEST }),
        success: (data) => ({ type: reconciliationConstants.LOAD_RECONCILIATIONS_SUCCESS, data }),
        failure: (error) => ({ type: reconciliationConstants.LOAD_RECONCILIATIONS_FAILURE, error })
    }
});


// WEBPACK FOOTER //
// ./src/redux/actions/reconciliation.actions.js